import { getCompanyEventCategories } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetCompanyEventCategories = () => {
  const { data } = useQuery(
    ['eventCategories'],
    () => getCompanyEventCategories(),
    { staleTime: 60000 }
  );

  return {
    eventCategories: data || [],
  };
};
